import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-circular-progressbar/dist/styles.css";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
import Tooltips from "@mui/material/Tooltip";
import { Chart as ChartJS, Title, Tooltip, Legend } from "chart.js";
ChartJS.register(Title, Tooltip, Legend);

export default function WarmUpAnalytics() {
  const history = useHistory();
  const locData = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  console.log('statde',locData.state)
  const [activeOption, setActiveOption] = useState("Week");
  const [graphData, setGraphData] = useState({});
  const [analyticData, setAnalyticData] = useState([]);
  const [senderMail, setSenderMail] = useState([]);
  const [delSent, setDelSent] = useState(0);
  const [delInbox, setDelInbox] = useState(0);
  const [graphLoader, setGraphLoader] = useState(true);
  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [scheduleCount, setScheduleCount] = useState(0);
  const [optionMax, setOptionmax] = useState(0);
  const [spamCount, setSpamCount] = useState(0);
  const [replyCount, setReplyCount] = useState(0);
  const [totalSent, setTotalSent] = useState(0);
  const [inbox, setInbox] = useState(0);

  const [value, setValue] = useState([null, null]);
  const monthShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const actionsArr = [
    {
      text: "Pause",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <path
            d="M8.875 16.8859V5.03594C8.875 3.91094 8.4 3.46094 7.2 3.46094H4.175C2.975 3.46094 2.5 3.91094 2.5 5.03594V16.8859C2.5 18.0109 2.975 18.4609 4.175 18.4609H7.2C8.4 18.4609 8.875 18.0109 8.875 16.8859Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.5 16.8859V5.03594C17.5 3.91094 17.025 3.46094 15.825 3.46094H12.8C11.6083 3.46094 11.125 3.91094 11.125 5.03594V16.8859C11.125 18.0109 11.6 18.4609 12.8 18.4609H15.825C17.025 18.4609 17.5 18.0109 17.5 16.8859Z"
            stroke="#1C485F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
    // {
    //   id: 2,
    //   text: "Edit",
    //   svg: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="20"
    //       height="24"
    //       viewBox="0 0 24 25"
    //       fill="none"
    //     >
    //       <path
    //         d="M11 2.96069H9C4 2.96069 2 4.96069 2 9.96069V15.9607C2 20.9607 4 22.9607 9 22.9607H15C20 22.9607 22 20.9607 22 15.9607V13.9607"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M16.0379 3.9807L8.15793 11.8607C7.85793 12.1607 7.55793 12.7507 7.49793 13.1807L7.06793 16.1907C6.90793 17.2807 7.67793 18.0407 8.76793 17.8907L11.7779 17.4607C12.1979 17.4007 12.7879 17.1007 13.0979 16.8007L20.9779 8.9207C22.3379 7.5607 22.9779 5.9807 20.9779 3.9807C18.9779 1.9807 17.3979 2.6207 16.0379 3.9807Z"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-miterlimit="10"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M14.9062 5.11072C15.5763 7.50072 17.4463 9.37072 19.8463 10.0507"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-miterlimit="10"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //     </svg>
    //   ),
    // },
    // {
    //   id: 3,
    //   text: "Complete",
    //   svg: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="20"
    //       height="24"
    //       viewBox="0 0 24 25"
    //       fill="none"
    //     >
    //       <path
    //         d="M11.9688 22.9607C17.4916 22.9607 21.9688 18.4835 21.9688 12.9607C21.9688 7.43785 17.4916 2.96069 11.9688 2.96069C6.4459 2.96069 1.96875 7.43785 1.96875 12.9607C1.96875 18.4835 6.4459 22.9607 11.9688 22.9607Z"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M10.7334 17.1907H13.2734C15.3934 17.1907 16.2334 16.3407 16.2334 14.2307V11.6907C16.2334 9.57071 15.3834 8.73071 13.2734 8.73071H10.7334C8.61344 8.73071 7.77344 9.58071 7.77344 11.6907V14.2307C7.77344 16.3407 8.62344 17.1907 10.7334 17.1907Z"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //     </svg>
    //   ),
    // },
    // {
    //   id: 4,
    //   text: "Delete",
    //   svg: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       width="24"
    //       height="24"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //     >
    //       <path
    //         d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M10.3301 16.5H13.6601"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //       <path
    //         d="M9.5 12.5H14.5"
    //         stroke="#1C485F"
    //         stroke-width="1.5"
    //         stroke-linecap="round"
    //         stroke-linejoin="round"
    //       />
    //     </svg>
    //   ),
    // },
  ];
  const progData = [
    {
      name: "Scheduled",
      value: 28,
      color: "#F3F3F3",
    },
    {
      name: "Inbox",
      value: 0,
      color: "#E9F7E9",
    },
    {
      name: "Spam",
      value: 0,
      color: "#FFEDE8",
    },
    {
      name: "Total Sent",
      value: 0,
      color: "#FDF2E1",
    },
    {
      name: "Replies",
      value: 0,
      color: "#F0F4FE",
    },
    {
      name: "Deliverability",
      value: 0,
      color: "#faf2f9",
    },
  ];
  const multipleOptions = [
    {
      id: 0,
      text: "Today",
    },
    {
      id: -1,
      text: "Yesterday",
    },
    {
      id: -6,
      text: "Week",
    },
    {
      id: -29,
      text: "Month",
    },
    {
      id: -356,
      text: "Year",
    },
  ];
  const dateRangePickerRef = useRef();
  useEffect(() => {
    if (dateRangePickerRef.current) {
      const handleChange = () => {
        const selectedDates = dateRangePickerRef.current.value;
        console.log("selected date", selectedDates);
      };

      dateRangePickerRef.current.onChange = handleChange;
    }
  }, [dateRangePickerRef]);

  var options=  {
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
    },
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          fontSize: 4,
        },
      },
      y: {
        beginAtZero: true,
        min: 0,
        max: optionMax,
        stepSize: 10,
      },
    },

    onHover: (event, elements) => {
      if (elements.length > 0) {
        const element = elements[0];
        const datasetIndex = element.datasetIndex;
        const index = element.index;
        const label = graphData.labels[index];
        const value = graphData.datasets[datasetIndex].data[index];
        if(activeOption==="Today"||activeOption==="Yesterday"){
          analyticData.Email.map((val) => {
            if (val.Date === label) {
              if(val.Warmup.length!==0){
                setTotalSent(val.Warmup.SentCount);
                setInbox(val.Warmup.InboxCount);
                setScheduleCount(val.Warmup.Email.length);
                setSpamCount(val.Warmup.SpamCount)
                setReplyCount(val.Warmup.ReplyCount)
              }
              else{
                setTotalSent(0);
                setInbox(0)
                setScheduleCount(0)
                setSpamCount(0)
                setReplyCount(0)
              }
            }
          });   
        }
        else
        {
          analyticData.map((val) => {
            if (val.Date === label) {
              if(val.Warmup.length!==0){
                setTotalSent(val.Warmup.SentCount);
                setInbox(val.Warmup.InboxCount);
                if(activeOption==="Year"){
                  setScheduleCount(val.Warmup.Email);
                }
                else
                {
                  setScheduleCount(val.Warmup.Email.length);
                }
                
                setSpamCount(val.Warmup.SpamCount)
                setReplyCount(val.Warmup.ReplyCount)
              }
              else{
                setTotalSent(0);
                setInbox(0)
                setScheduleCount(0)
                setSpamCount(0)
                setReplyCount(0)
              }
            }
          });   
        }
       
      }
    },
  }
  function convertedDayTime(date){
    const timestamp = new Date(date);
    const options = { month: 'short', day: 'numeric' };
    const formattedDate = timestamp.toLocaleDateString('en-US', options);
    return formattedDate;
  }
  function getWarmupAnalytic(type) {
    let config = {
      method: "get",  
      maxBodyLength: Infinity,  
      url: `${
        BaseUrl.baseurl
      }/email-marketing/warmup/get-warmup-analytic/${
        userDetails && userDetails?.details?._id
      }/${locData.state?.FromEmail}/${type}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };
    axios
      .request(config)
      .then((res) => {
        if (res.data.status) {
          
          let labelDate = [];
          let valueData = [];
          let valueData2 = [];
          if(type==="Today"||type==="Yesterday"){
            setDelSent(res.data.details.SentCount)
            setDelInbox(res.data.details.InboxCount)
            res.data.details.Email.map((val) => {
              labelDate.push(
                `${val.Date}`
              );
              val.Date = `${val.Date}`;
              valueData.push(val.Warmup.length!==0?val.Warmup.Email.length:0);
              valueData2.push(val.Warmup.length!==0?val.Warmup.SentCount:0);
             
              
            });
          }
          else
          {
            setDelSent(res.data.warmup.SentCount)
            setDelInbox(res.data.warmup.InboxCount)
            res.data.details.map((val) => {
              if(type==="Year"){
                labelDate.push(
                  `${val.Date}`
                );
                val.Date = `${val.Date}`;
                valueData.push(val.Warmup.length!==0?val.Warmup.Email:0);
              }
              else
              {
                labelDate.push(
                  `${convertedDayTime(val.Date)}`
                );
                val.Date = `${convertedDayTime(val.Date)}`;
                valueData.push(val.Warmup.length!==0?val.Warmup.Email.length:0);
              }
              valueData2.push(val.Warmup.length!==0?val.Warmup.SentCount:0);
             
              
            });
          }
         
          //  options.scales.y.max=Math.max(...valueData)+1;
          setOptionmax(Math.max(...valueData)+1)
          setAnalyticData(res.data.details);
          setGraphData({
            labels: labelDate,
            datasets: [
              {
                data: valueData,
                backgroundColor: "#F3F3F3",
                borderRadius: 4,
                borderWidth: 1.5,
                pointLabel: 1,
                borderColor: "#868686",
                order: 1,
                pointHoverRadius: 8,
                pointHoverBorderWidth: 3,
                hitRadius: 10,
              },
              {
                data: valueData2,
                backgroundColor: "#97B4C9",
                categoryPercentage: 0.78,
                order: 0,
                pointHoverRadius: 8,
                pointHoverBorderWidth: 3,
                hitRadius: 10,
              },
            ],
          });
        } else {
          setGraphData({})
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setLoader(false)
        setGraphLoader(false);
      });
  }
  function getEmailbyId(){
    axios
    .get(
      `${
        BaseUrl.baseurl
      }/email-marketing/user-from-email/get-single-from-emails-details/${
        userDetails && userDetails.details._id
      }/${locData.state._id}`,
      {
        headers: {
          Authorization: `Bearear ${userDetails && userDetails.token}`,
        },
      }
    )
    .then((response) => {
      if (response.data.status) {
        console.log(
          "response.data.details.AddedEmails",
          response.data.details.AddedEmails
        );
        setSenderMail(response.data.details);
      } else {
        setSenderMail([]);
        if (response.data.tokenExpire) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      }
    })
    .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getWarmupAnalytic('Week');
    getEmailbyId()
  }, []);

 
  function pauseEmailWarmUp() {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-from-email/pause-warmup/${
        userDetails && userDetails.details._id
      }/${locData.state._id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          getEmailbyId();
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function resumeEmailWarmUP() {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-from-email/resume-warmup/${
        userDetails && userDetails.details._id
      }/${locData.state._id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          getEmailbyId();
        } else {
          toast.error(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function completeEmailWarmUp() {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/warmup-campaign/complete-warmup-campaign/${
        userDetails && userDetails?.details?._id
      }/${locData.state?.WarmUpDetails._id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          // getEmailWarmUpByid();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function deleteEmailWarmUp() {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${
        BaseUrl.baseurl
      }/email-marketing/warmup-campaign/delete-warm-up-details/${
        userDetails && userDetails?.details?._id
      }/${locData.state?.WarmUpDetails._id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          history.goBack();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function generateDateRangeString(range) {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + range);

    const startDayMonth = today.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
    });
    const endDayMonth = endDate.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
    });

    return `${startDayMonth} - ${endDayMonth} ${endDate.getFullYear()}`;
  }
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        // padding: "4px",
        borderRadius: "5px",
        backgroundColor: "#FFF",
        border:'1px solid #DDD',
      }}
    >
      <Box>
        {loader ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "120px",
            }}
          >
            <CircularProgress
              size={30}
              style={{
                color: "#1C485F",
              }}
            />
          </div>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 12px",
              }}
            >
              <div style={{ display: "flex", gap: "10px" }}>
                {/* <h1
                  style={{
                    fontFamily: " Source Sans 3",
                    fontStyle: "normal",
                    color: "#393939",
                    fontSize: "20px",
                    fontWeight: 700,
                  }}
                >
                  Warm-up campaign progress
                </h1> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="emailwarmupboxname">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M11.333 13.6673H4.66634C2.66634 13.6673 1.33301 12.6673 1.33301 10.334V5.66732C1.33301 3.33398 2.66634 2.33398 4.66634 2.33398H11.333C13.333 2.33398 14.6663 3.33398 14.6663 5.66732V10.334C14.6663 12.6673 13.333 13.6673 11.333 13.6673Z"
                        stroke="#009C35"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
                        stroke="#009C35"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {locData.state?.FromEmail}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "14px",
                }}
              >
                {senderMail&&!senderMail?.WarmUp.Status? (
                  <div className="pausedstatusbutton">Paused</div>
               ):<div className="ongoingstatusbuttton">Ongoing</div>}
                {/* <div
                  style={{
                    backgroundColor: "#e9f7e9",
                    borderRadius: "25px",
                    padding: "3px 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    height: "max-content",
                  }}
                >
                  <div
                    style={{
                      height: "10px",
                      width: "10px",
                      borderRadius: "100%",
                      backgroundColor: "#53D86A",
                    }}
                  ></div>
                  <div
                    style={{
                      fontFamily: " Source Sans 3",
                      fontStyle: "normal",
                      color: "#53D86A",
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    {locData.state?.WarmUp.Status}
                  </div>
                </div> */}
                {actionsArr.map((data, idx) => (
                  <button
                    onClick={() => {
                      if (idx === 0) {
                        if (senderMail.WarmUp.Status) {
                          pauseEmailWarmUp();
                        } else{
                          resumeEmailWarmUP();
                        }
                      } else if (idx === 1) {
                        completeEmailWarmUp();
                      } else if (idx === 2) {
                        setOpen(true);
                      }
                    }}
                    key={data.id}
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      fontFamily: " Source Sans 3",
                      fontStyle: "normal",
                      color: "#393939",
                      fontSize: "14px",
                      outline: "none",
                    }}
                  >
                    {idx === 0 ? (
                      !senderMail.WarmUp.Status? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <path
                            d="M9.97591 19.294C14.5783 19.294 18.3092 15.5631 18.3092 10.9607C18.3092 6.35834 14.5783 2.62738 9.97591 2.62738C5.37354 2.62738 1.64258 6.35834 1.64258 10.9607C1.64258 15.5631 5.37354 19.294 9.97591 19.294Z"
                            stroke="#1C485F"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.2832 11.1524V9.76072C7.2832 8.02738 8.5082 7.31905 10.0082 8.18572L11.2165 8.88572L12.4249 9.58572C13.9249 10.4524 13.9249 11.869 12.4249 12.7357L11.2165 13.4357L10.0082 14.1357C8.5082 15.0024 7.2832 14.294 7.2832 12.5607V11.1524Z"
                            stroke="#1C485F"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : (
                        data.svg
                      )
                    ) : (
                      data.svg
                    )}
                    {idx === 0
                      ? !senderMail.WarmUp.Status
                        ? "Resume"
                        : data.text
                      : data.text}
                  </button>
                ))}
              </div>
            </Box>
            <Box
              sx={{
                backgroundColor: "#fff",
                width: "100%",
                padding: "0px 0px",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
              }}
            >
              <Box sx={{ borderBottomWidth: "1px", position: "relative" }}>
                <div
                  style={{
                    display: "flex",
                    padding: "5px 16px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexGrow: 1,
                      gap: "25px",
                      position: "relative",
                    }}
                  >
                    {multipleOptions.map((option, i) => (
                      <Tooltips
                        title={`${
                          generateDateRangeString(option.id)
                        }`}
                        arrow
                      >
                        <button
                          key={option.id}
                          onClick={() => {
                            getWarmupAnalytic(option.text);
                            setActiveOption(option.text);
                          }}
                          style={{
                            fontFamily: " Source Sans 3",
                            fontStyle: "normal",
                            color:
                              activeOption === option.text
                                ? "#1C485F"
                                : "#727272",
                            fontSize: "14px",
                            fontWeight: 700,
                            display: "flex",
                            justifyContent: "space-between",
                            outline: "none",
                            alignItems: "center",
                            gap: "4px",
                            borderBottom:
                              activeOption === option.text
                                ? "2px solid #1C485F"
                                : "2px solid #fff",
                          }}
                        >
                          {option.text}
                        </button>
                      </Tooltips>
                    ))}
                    {/* <DateRangePicker
                      value={value}
                      ref={dateRangePickerRef}
                      disabledDate={disabledDate}
                      showOneCalendar
                      placeholder="Cusotm range"
                      placement="bottomEnd"
                      size="sm"
                      onOk={(e) => {
                        getCustomAnalytics(e);
                      }}
                      ranges={[]}
                    /> */}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 16,
                      position: "relative",
                      zIndex: 100,
                    }}
                  >
                    {/* <input type="text" style={{ backgroundColor: "#DAE0E2", padding: "6px 12px", borderRadius: "10px", outline: "none", }} /> */}
                    {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M9.58073 18.4607C13.953 18.4607 17.4974 14.9162 17.4974 10.544C17.4974 6.17173 13.953 2.62732 9.58073 2.62732C5.20847 2.62732 1.66406 6.17173 1.66406 10.544C1.66406 14.9162 5.20847 18.4607 9.58073 18.4607Z"
                      stroke="#868686"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.3307 19.294L16.6641 17.6273"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg> */}

                    {/* <CustomeSurendra setValue={setValue} value={value} CampaignCreatedDate={campaignDetails.CampaignCreatedDate} /> */}
                  </div>
                </div>
              </Box>
            </Box>
            <div
              style={{
                display: "grid",
                gap: "16px",
                gridTemplateColumns: "repeat(8, 1fr) repeat(4, 1fr)",
                backgroundColor: "#FFF",
                padding: "12px",
                borderBottomRightRadius: "6px",
                borderBottomLeftRadius: "6px",
              }}
            >
              <div
                style={{
                  gridColumn: "span 12",
                  backgroundColor: "#FFF",
                  boxShadow:
                    "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                  borderRadius: "6px",
                }}
              >
                {/* <div className="stratergynamebocx">
                  Deliverability 
                  <Tooltips
                    title="This graph shows the progress of your warm-up campaign. Gray bars indicate the email messages scheduled for sending for a particular day. Green, yellow and red bars indicate your deliverability - whether the email landed in the Inbox (green), Categories (yellow) or the Spam folder (red). The blue line indicates the number of replies you receive according to campaign settings."
                    arrow
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 16V11"
                        stroke="#393939"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.0059 8H11.9969"
                        stroke="#393939"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Tooltips>
                </div> */}
                <div
                  // className="analyticshcedulebox"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6,1fr)",
                    gap: "8px",
                    padding: "8px",
                  }}
                >
                  {progData.map((val, idx) => {
                    return (
                      <div
                        className="insideboxanawarmup"
                        style={{ background: val.color }}
                      >
                        <div>
                          <div className="warmupshcednumber">
                            {idx === 0
                              ? scheduleCount
                              : idx === 1
                              ? inbox
                              : idx === 2
                              ? spamCount
                              : idx === 3
                              ? totalSent
                              :idx === 4?replyCount:idx === 5?`${isNaN((delInbox/delSent*100).toFixed(0))?0:(delInbox/delSent*100).toFixed(0)}%`:val.value}
                          </div>
                          <div className="wamruplabelnameana">{val.name}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {graphLoader ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <CircularProgress
                      size={30}
                      style={{
                        color: "#1C485F",
                      }}
                    />
                  </div>
                ) : (
                  <>
                    {graphData && (
                      <Bar
                        className="bargraphheight"
                        options={options}
                        data={graphData}
                      />
                    )}
                  </>
                )}

                
              </div>
             
            </div>
          </>
        )}

        <Modal
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="modalPopupDelete">
            <div className="modaltext">Confirm Delete</div>
            <div className="modalsubtext">
              Are you sure you want to delete this warmup?
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                width: "100%",
              }}
            >
              <div
                className="cancelbuttonmodal"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </div>
              <div
                className="continuebuttonmodal"
                onClick={() => {
                  deleteEmailWarmUp();
                }}
              >
                Continue
              </div>
            </div>
          </div>
        </Modal>
      </Box>
      <ToastContainer />
    </div>
  );
}
